"use client";
import { createContext } from "react";

export type ApplicationFormLayoutContext = {
  formTemplate: {
    id: string;
    name: string;
    slot: string;
  };
};

const LayoutContext = createContext<ApplicationFormLayoutContext>(null!);

export default LayoutContext;
